<div class="wrapper">
  <div id="aiChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #aiChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>AI graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>